export default "__VITE_ASSET__0705593f__"